export var RECOMMENDATIONS_SCRIPT_URL = '//media.algorecs.com/rrserver/js/2.1/p13n.js';